<template>
  <div class="supportH5" ref="supportH5">
    <div class="support">
      <div class="select-box">
        <div class="text">服务与支持</div>
        <div class="ipt-box">
          <img src="~@/assets/search.png" class="img-search" alt="" />
          <input type="text" class="ipt" placeholder="输入要查找问题的关键词" />
        </div>
      </div>
    </div>
    <div class="pos">
      <div class="title"><span></span> 收银产品</div>
      <div class="pos-list">
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="pos pos1">
      <div class="title"><span></span> 收银产品</div>
      <div class="pos-list">
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="pos pos1 pos2">
      <div class="title"><span></span> 收银产品</div>
      <div class="pos-list">
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
        <div class="pos-item">
          <div class="left">什么是智慧零售？</div>
          <div class="right">
            <img src="~@/assets/back-r.png" class="img" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    this.$refs.supportH5.scrollIntoView();
  },
};
</script>
<style lang="less" scoped>
.supportH5 {
  background: #f5f7fa;
  padding-bottom: 40px;
  .support {
    width: 750px;
    height: 520px;
    background: url("~@/assets/support.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .select-box {
      width: 640px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .text {
        font-weight: 700;
        font-size: 64px;
        line-height: 80px;
        color: #292929;
        margin-bottom: 24px;
      }
      .ipt-box {
        width: 640px;
        height: 96px;
        padding: 0 32px;
        display: flex;
        align-items: center;
        overflow: hidden;
        background: #ffffff;
        box-shadow: 4px 4px 12px rgba(55, 99, 170, 0.08);
        border-radius: 50px;
        .img-search {
          width: 36px;
          height: 36px;
          margin-right: 8px;
        }
        .ipt {
          width: 400px;
          height: 40px;
          font-size: 32px;
          border: 0;
          outline: none;
        }
      }
    }
  }
  .pos {
    margin: 0 32px;
    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 36px;
      line-height: 44px;
      color: #202d40;
      margin-bottom: 24px;
      span {
        display: inline-block;
        width: 8px;
        height: 64px;
        margin-right: 24px;
        background: #336fff;
        border-radius: 2px;
      }
    }
    .pos-list {
      border-radius: 16px;
      background: #fff;
      padding: 0 32px;
      .pos-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 108px;
        border-bottom: 1px solid #cccccc;
        .left {
          flex: 1;
          font-size: 32px;
          line-height: 40px;
          color: #626e81;
        }
        .right {
          width: 44px;
          height: 44px;
          .img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .pos-item:last-child {
        border-bottom: 0;
      }
    }
  }
  .pos1 {
    margin-top: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/supportH5.vue